import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'wms/param';

const wmsParamService = {
  getAll: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/all`,
    });
  },
};

export default wmsParamService;
